import React, { useState } from 'react';
import { Card, Tag } from 'antd';
import colors from '../../utils/theme/colors';

const TAB_LABELS = {
  success: 'Success',
  error: 'Error',
  webhook_success: 'Webhook Success',
  webhook_error: 'Webhook Error',
};

function getTabColor(tab) {
  if (tab === 'success' || tab === 'webhook_success') return '#10b981';
  return '#ef4444';
}

export default function ResponseExampleCard({ title, responses }) {
  const tabs = Object.keys(responses);
  const [activeTab, setActiveTab] = useState(tabs[0] || 'success');

  return (
    <Card
      title={title || 'Response Examples'}
      style={{
        marginTop: 16,
        background: colors.card,
        border: `1px solid ${colors.border}`,
      }}
    >
      <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap' }}>
        {tabs.map((tab) => {
          const color = getTabColor(tab);
          const isActive = activeTab === tab;
          return (
            <Tag
              key={tab}
              onClick={() => setActiveTab(tab)}
              style={{
                cursor: 'pointer',
                padding: '4px 12px',
                borderRadius: 6,
                border: isActive ? `1px solid ${color}` : `1px solid ${colors.border}`,
                background: isActive ? `${color}20` : 'transparent',
                color: isActive ? color : colors.muted_foreground,
                fontWeight: 500,
                fontSize: 12,
              }}
            >
              {TAB_LABELS[tab] || tab.replace(/_/g, ' ')}
            </Tag>
          );
        })}
      </div>

      <div
        style={{
          background: '#0a0a0a',
          borderRadius: 8,
          padding: 16,
          overflowX: 'auto',
          border: `1px solid ${colors.border}`,
        }}
      >
        <pre
          style={{
            margin: 0,
            color: '#e5e5e5',
            fontSize: 13,
            lineHeight: 1.6,
            fontFamily: "'Fira Code', 'Consolas', 'Monaco', monospace",
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
          }}
        >
          <code>{JSON.stringify(responses[activeTab], null, 2)}</code>
        </pre>
      </div>
    </Card>
  );
}
